export const ActionTypes = {
  USER_LOGIN: 'USER_LOGIN',
  LOAD_USERS: 'LOAD_USERS',
  TEAM_LOGIN: 'TEAM_LOGIN',
  LOAD_TEAMS: 'LOAD_TEAMS',
  USER_LOGOUT: 'USER_LOGOUT',

  LOAD_CURRENT_TEAM: 'LOAD_CURRENT_TEAM',
};
